// Auto-generated from merged people data
// List of people mentioned in documents, ordered by mention count

export const peopleData = [
  {
    "name": "Jeffrey Epstein",
    "count": 5198,
    "contexts": []
  },
  {
    "name": "Donald Trump",
    "count": 1827,
    "contexts": []
  },
  {
    "name": "Bill Clinton",
    "count": 922,
    "contexts": []
  },
  {
    "name": "Alan M Dershowitz",
    "count": 725,
    "contexts": []
  },
  {
    "name": "Barack Obama",
    "count": 661,
    "contexts": []
  },
  {
    "name": "Edward Snowden",
    "count": 517,
    "contexts": []
  },
  {
    "name": "Bradley Edwards",
    "count": 514,
    "contexts": []
  },
  {
    "name": "Steve Bannon",
    "count": 450,
    "contexts": []
  },
  {
    "name": "Ghislaine Maxwell",
    "count": 437,
    "contexts": []
  },
  {
    "name": "Prince Andrew",
    "count": 360,
    "contexts": []
  },
  {
    "name": "Virginia Roberts",
    "count": 309,
    "contexts": []
  },
  {
    "name": "Hillary Clinton",
    "count": 271,
    "contexts": []
  },
  {
    "name": "Benjamin Netanyahu",
    "count": 249,
    "contexts": []
  },
  {
    "name": "Kathryn Ruemmler",
    "count": 224,
    "contexts": []
  },
  {
    "name": "Landon Thomas",
    "count": 217,
    "contexts": []
  },
  {
    "name": "Michael Wolff",
    "count": 216,
    "contexts": []
  },
  {
    "name": "David Schoen",
    "count": 206,
    "contexts": []
  },
  {
    "name": "Darren Indyke",
    "count": 182,
    "contexts": []
  },
  {
    "name": "Richard Kahn",
    "count": 181,
    "contexts": []
  },
  {
    "name": "Reid Weingarten",
    "count": 178,
    "contexts": []
  },
  {
    "name": "Arafat",
    "count": 177,
    "contexts": []
  },
  {
    "name": "Vladimir Putin",
    "count": 177,
    "contexts": []
  },
  {
    "name": "Ehud Barak",
    "count": 175,
    "contexts": []
  },
  {
    "name": "Paul Cassell",
    "count": 161,
    "contexts": []
  },
  {
    "name": "Lawrence Krauss",
    "count": 159,
    "contexts": []
  },
  {
    "name": "Leslie Wexner",
    "count": 151,
    "contexts": []
  },
  {
    "name": "James Patterson",
    "count": 142,
    "contexts": []
  },
  {
    "name": "Larry Summers",
    "count": 142,
    "contexts": []
  },
  {
    "name": "George Bush",
    "count": 139,
    "contexts": []
  },
  {
    "name": "Melanie Spinella",
    "count": 129,
    "contexts": []
  },
  {
    "name": "Jack Goldberger",
    "count": 128,
    "contexts": []
  },
  {
    "name": "Martin G Weinberg",
    "count": 127,
    "contexts": []
  },
  {
    "name": "Rabin",
    "count": 125,
    "contexts": []
  },
  {
    "name": "Jean Luc Brunel",
    "count": 115,
    "contexts": []
  },
  {
    "name": "Cassell",
    "count": 113,
    "contexts": []
  },
  {
    "name": "Robert Kuhn",
    "count": 113,
    "contexts": []
  },
  {
    "name": "Steven Hoffenberg",
    "count": 105,
    "contexts": []
  },
  {
    "name": "Xi Jinping",
    "count": 104,
    "contexts": []
  },
  {
    "name": "Al Gore",
    "count": 103,
    "contexts": []
  },
  {
    "name": "Jared Kushner",
    "count": 101,
    "contexts": []
  },
  {
    "name": "Mccawley",
    "count": 91,
    "contexts": []
  },
  {
    "name": "Michael Reiter",
    "count": 90,
    "contexts": []
  },
  {
    "name": "Assad",
    "count": 90,
    "contexts": []
  },
  {
    "name": "Bill Gates",
    "count": 87,
    "contexts": []
  },
  {
    "name": "Tein",
    "count": 86,
    "contexts": []
  },
  {
    "name": "Shimon Peres",
    "count": 85,
    "contexts": []
  },
  {
    "name": "Kenneth Starr",
    "count": 83,
    "contexts": []
  },
  {
    "name": "Leopold",
    "count": 83,
    "contexts": []
  },
  {
    "name": "Glenn Greenwald",
    "count": 82,
    "contexts": []
  },
  {
    "name": "Norbert Wiener",
    "count": 81,
    "contexts": []
  },
  {
    "name": "Barry Krischer",
    "count": 80,
    "contexts": []
  },
  {
    "name": "Woody Allen",
    "count": 79,
    "contexts": []
  },
  {
    "name": "Jay Lefkowitz",
    "count": 79,
    "contexts": []
  },
  {
    "name": "Giuffre",
    "count": 76,
    "contexts": []
  },
  {
    "name": "Sarah Kellen",
    "count": 75,
    "contexts": []
  },
  {
    "name": "Yitzhak Rabin",
    "count": 74,
    "contexts": []
  },
  {
    "name": "Scott Rothstein",
    "count": 73,
    "contexts": []
  },
  {
    "name": "Alfredo Rodriguez",
    "count": 73,
    "contexts": []
  },
  {
    "name": "Ken Starr",
    "count": 72,
    "contexts": []
  },
  {
    "name": "Robert Maxwell",
    "count": 72,
    "contexts": []
  },
  {
    "name": "Laura Poitras",
    "count": 72,
    "contexts": []
  },
  {
    "name": "Joslin",
    "count": 72,
    "contexts": []
  },
  {
    "name": "Osama Bin Laden",
    "count": 72,
    "contexts": []
  },
  {
    "name": "Roberts",
    "count": 72,
    "contexts": []
  },
  {
    "name": "Lesley Groff",
    "count": 69,
    "contexts": []
  },
  {
    "name": "Eileen",
    "count": 69,
    "contexts": []
  },
  {
    "name": "Nicholas Ribis",
    "count": 69,
    "contexts": []
  },
  {
    "name": "Dershowitz",
    "count": 69,
    "contexts": []
  },
  {
    "name": "Michael Cella",
    "count": 67,
    "contexts": []
  },
  {
    "name": "Alan Turing",
    "count": 66,
    "contexts": []
  },
  {
    "name": "Bush",
    "count": 66,
    "contexts": []
  },
  {
    "name": "Elisa New",
    "count": 65,
    "contexts": []
  },
  {
    "name": "Virginia L Giuffre",
    "count": 65,
    "contexts": []
  },
  {
    "name": "Bill",
    "count": 64,
    "contexts": []
  },
  {
    "name": "Arik",
    "count": 64,
    "contexts": []
  },
  {
    "name": "Woody",
    "count": 64,
    "contexts": []
  },
  {
    "name": "Ghislaine",
    "count": 63,
    "contexts": []
  },
  {
    "name": "Boris Nikolic",
    "count": 63,
    "contexts": []
  },
  {
    "name": "Leon Black",
    "count": 63,
    "contexts": []
  },
  {
    "name": "Larry",
    "count": 63,
    "contexts": []
  },
  {
    "name": "Donald",
    "count": 63,
    "contexts": []
  },
  {
    "name": "Roy Black",
    "count": 61,
    "contexts": []
  },
  {
    "name": "Alan",
    "count": 61,
    "contexts": []
  },
  {
    "name": "Scott",
    "count": 61,
    "contexts": []
  },
  {
    "name": "Larry Visoski",
    "count": 60,
    "contexts": []
  },
  {
    "name": "Ivanka Trump",
    "count": 60,
    "contexts": []
  },
  {
    "name": "Nadia Marcinkova",
    "count": 59,
    "contexts": []
  },
  {
    "name": "Richard Dawkins",
    "count": 59,
    "contexts": []
  },
  {
    "name": "Yasser Arafat",
    "count": 59,
    "contexts": []
  },
  {
    "name": "Acosta",
    "count": 58,
    "contexts": []
  },
  {
    "name": "Paul Krassner",
    "count": 58,
    "contexts": []
  },
  {
    "name": "Poitras",
    "count": 58,
    "contexts": []
  },
  {
    "name": "Peres",
    "count": 57,
    "contexts": []
  },
  {
    "name": "Greenwald",
    "count": 57,
    "contexts": []
  },
  {
    "name": "Robert Mueller",
    "count": 57,
    "contexts": []
  },
  {
    "name": "Michael Flynn",
    "count": 56,
    "contexts": []
  },
  {
    "name": "Jack Scarola",
    "count": 55,
    "contexts": []
  },
  {
    "name": "Brad Wechsler",
    "count": 55,
    "contexts": []
  },
  {
    "name": "Mueller",
    "count": 54,
    "contexts": []
  },
  {
    "name": "Mill",
    "count": 53,
    "contexts": []
  },
  {
    "name": "Jared",
    "count": 53,
    "contexts": []
  },
  {
    "name": "Goldberger",
    "count": 53,
    "contexts": []
  },
  {
    "name": "Detective Recarey",
    "count": 52,
    "contexts": []
  },
  {
    "name": "Ronald Reagan",
    "count": 51,
    "contexts": []
  },
  {
    "name": "Harvey Weinstein",
    "count": 51,
    "contexts": []
  },
  {
    "name": "Andrew",
    "count": 51,
    "contexts": []
  },
  {
    "name": "Dado",
    "count": 50,
    "contexts": []
  },
  {
    "name": "Bashar Al-assad",
    "count": 50,
    "contexts": []
  },
  {
    "name": "Noam Chomsky",
    "count": 49,
    "contexts": []
  },
  {
    "name": "Wiener",
    "count": 49,
    "contexts": []
  },
  {
    "name": "Clarisse Thorn",
    "count": 49,
    "contexts": []
  },
  {
    "name": "John Mccain",
    "count": 49,
    "contexts": []
  },
  {
    "name": "Graydon Carter",
    "count": 48,
    "contexts": []
  },
  {
    "name": "Barak",
    "count": 48,
    "contexts": []
  },
  {
    "name": "Priebus",
    "count": 48,
    "contexts": []
  },
  {
    "name": "Reiter",
    "count": 48,
    "contexts": []
  },
  {
    "name": "Peggy Siegal",
    "count": 47,
    "contexts": []
  },
  {
    "name": "Reince Priebus",
    "count": 47,
    "contexts": []
  },
  {
    "name": "Mort Zuckerman",
    "count": 46,
    "contexts": []
  },
  {
    "name": "Kevin Spacey",
    "count": 45,
    "contexts": []
  },
  {
    "name": "Julian Assange",
    "count": 45,
    "contexts": []
  },
  {
    "name": "Kushner",
    "count": 45,
    "contexts": []
  },
  {
    "name": "Hoffman",
    "count": 45,
    "contexts": []
  },
  {
    "name": "Gerald Lefcourt",
    "count": 45,
    "contexts": []
  },
  {
    "name": "Stephen Hawking",
    "count": 44,
    "contexts": []
  },
  {
    "name": "Ben-gurion",
    "count": 44,
    "contexts": []
  },
  {
    "name": "Alexander Acosta",
    "count": 44,
    "contexts": []
  },
  {
    "name": "Jeff Sessions",
    "count": 44,
    "contexts": []
  },
  {
    "name": "Fried",
    "count": 44,
    "contexts": []
  },
  {
    "name": "Kellyanne Conway",
    "count": 44,
    "contexts": []
  },
  {
    "name": "Lisa New",
    "count": 44,
    "contexts": []
  },
  {
    "name": "Richard Nixon",
    "count": 44,
    "contexts": []
  },
  {
    "name": "Mary",
    "count": 43,
    "contexts": []
  },
  {
    "name": "Henry Kissinger",
    "count": 43,
    "contexts": []
  },
  {
    "name": "Avraham",
    "count": 43,
    "contexts": []
  },
  {
    "name": "Begin",
    "count": 43,
    "contexts": []
  },
  {
    "name": "Peter Thiel",
    "count": 43,
    "contexts": []
  },
  {
    "name": "Lhs",
    "count": 43,
    "contexts": []
  },
  {
    "name": "Wolfe Von Lenkiewicz",
    "count": 43,
    "contexts": []
  },
  {
    "name": "Kyl",
    "count": 43,
    "contexts": []
  },
  {
    "name": "Virginia",
    "count": 42,
    "contexts": []
  },
  {
    "name": "Debra",
    "count": 42,
    "contexts": []
  },
  {
    "name": "Turing",
    "count": 42,
    "contexts": []
  },
  {
    "name": "Greenberg",
    "count": 42,
    "contexts": []
  },
  {
    "name": "Sarah",
    "count": 42,
    "contexts": []
  },
  {
    "name": "Bill Richardson",
    "count": 41,
    "contexts": []
  },
  {
    "name": "Dennis Ross",
    "count": 41,
    "contexts": []
  },
  {
    "name": "Ivanka",
    "count": 41,
    "contexts": []
  },
  {
    "name": "Rod Rosenstein",
    "count": 41,
    "contexts": []
  },
  {
    "name": "Haley Robson",
    "count": 40,
    "contexts": []
  },
  {
    "name": "Elon Musk",
    "count": 40,
    "contexts": []
  },
  {
    "name": "Danny Yatom",
    "count": 40,
    "contexts": []
  },
  {
    "name": "Amnon Lipkin",
    "count": 40,
    "contexts": []
  },
  {
    "name": "Joseph Recarey",
    "count": 40,
    "contexts": []
  },
  {
    "name": "Joe Biden",
    "count": 40,
    "contexts": []
  },
  {
    "name": "James Comey",
    "count": 40,
    "contexts": []
  },
  {
    "name": "Ghislane",
    "count": 40,
    "contexts": []
  },
  {
    "name": "Victoria Golembiovskaya",
    "count": 40,
    "contexts": []
  },
  {
    "name": "Barry",
    "count": 40,
    "contexts": []
  },
  {
    "name": "Heather",
    "count": 40,
    "contexts": []
  },
  {
    "name": "Michael Cohen",
    "count": 40,
    "contexts": []
  },
  {
    "name": "Vicky Ward",
    "count": 39,
    "contexts": []
  },
  {
    "name": "Alex Acosta",
    "count": 39,
    "contexts": []
  },
  {
    "name": "David Boies",
    "count": 39,
    "contexts": []
  },
  {
    "name": "Ochstein",
    "count": 39,
    "contexts": []
  },
  {
    "name": "Claude Shannon",
    "count": 39,
    "contexts": []
  },
  {
    "name": "Nickie Altomaro",
    "count": 39,
    "contexts": []
  },
  {
    "name": "Oliver Stone",
    "count": 38,
    "contexts": []
  },
  {
    "name": "Shlomo Ben-ami",
    "count": 38,
    "contexts": []
  },
  {
    "name": "Hosni Mubarak",
    "count": 38,
    "contexts": []
  },
  {
    "name": "Marra",
    "count": 38,
    "contexts": []
  },
  {
    "name": "Lawrence Summers",
    "count": 38,
    "contexts": []
  },
  {
    "name": "Jack",
    "count": 38,
    "contexts": []
  },
  {
    "name": "Tony Blair",
    "count": 37,
    "contexts": []
  },
  {
    "name": "Deepak Chopra",
    "count": 37,
    "contexts": []
  },
  {
    "name": "Jessica Cadwell",
    "count": 37,
    "contexts": []
  },
  {
    "name": "Lilly Sanchez",
    "count": 37,
    "contexts": []
  },
  {
    "name": "Djt",
    "count": 37,
    "contexts": []
  },
  {
    "name": "Arik Sharon",
    "count": 36,
    "contexts": []
  },
  {
    "name": "Yoni",
    "count": 36,
    "contexts": []
  },
  {
    "name": "Jimmy Cayne",
    "count": 36,
    "contexts": []
  },
  {
    "name": "Patrick Bertagna",
    "count": 36,
    "contexts": []
  },
  {
    "name": "Lindsay Mills",
    "count": 36,
    "contexts": []
  },
  {
    "name": "Brad S Karp",
    "count": 36,
    "contexts": []
  },
  {
    "name": "Hafez Al-assad",
    "count": 35,
    "contexts": []
  },
  {
    "name": "Mp",
    "count": 35,
    "contexts": []
  },
  {
    "name": "Tom Barrack",
    "count": 35,
    "contexts": []
  },
  {
    "name": "Kucherena",
    "count": 35,
    "contexts": []
  },
  {
    "name": "Comey",
    "count": 35,
    "contexts": []
  },
  {
    "name": "George Mitchell",
    "count": 35,
    "contexts": []
  },
  {
    "name": "Sigrid Mccawley",
    "count": 35,
    "contexts": []
  },
  {
    "name": "Bibi Netanyahu",
    "count": 34,
    "contexts": []
  },
  {
    "name": "Dayan",
    "count": 34,
    "contexts": []
  },
  {
    "name": "Hope Hicks",
    "count": 34,
    "contexts": []
  },
  {
    "name": "George",
    "count": 34,
    "contexts": []
  },
  {
    "name": "Sultan Bin Sulayem",
    "count": 34,
    "contexts": []
  },
  {
    "name": "Joi Ito",
    "count": 34,
    "contexts": []
  },
  {
    "name": "Gates",
    "count": 34,
    "contexts": []
  },
  {
    "name": "Motta",
    "count": 33,
    "contexts": []
  },
  {
    "name": "Duemler",
    "count": 33,
    "contexts": []
  },
  {
    "name": "Mick Jagger",
    "count": 32,
    "contexts": []
  },
  {
    "name": "Nigel Farage",
    "count": 32,
    "contexts": []
  },
  {
    "name": "Katie Couric",
    "count": 32,
    "contexts": []
  },
  {
    "name": "Barton Gellman",
    "count": 32,
    "contexts": []
  },
  {
    "name": "Ada",
    "count": 32,
    "contexts": []
  },
  {
    "name": "Rebecca Watson",
    "count": 32,
    "contexts": []
  },
  {
    "name": "Steven Pinker",
    "count": 32,
    "contexts": []
  },
  {
    "name": "Wendy",
    "count": 32,
    "contexts": []
  },
  {
    "name": "Jonathan Farkas",
    "count": 32,
    "contexts": []
  },
  {
    "name": "Kennedy",
    "count": 32,
    "contexts": []
  },
  {
    "name": "R Alexander Acosta",
    "count": 31,
    "contexts": []
  },
  {
    "name": "Mark Filip",
    "count": 31,
    "contexts": []
  },
  {
    "name": "Ace Greenberg",
    "count": 31,
    "contexts": []
  },
  {
    "name": "Francis J Kelly",
    "count": 31,
    "contexts": []
  },
  {
    "name": "Mubarak",
    "count": 31,
    "contexts": []
  },
  {
    "name": "Walton",
    "count": 31,
    "contexts": []
  },
  {
    "name": "John F Kennedy",
    "count": 31,
    "contexts": []
  },
  {
    "name": "Mbs",
    "count": 31,
    "contexts": []
  },
  {
    "name": "Rupert Murdoch",
    "count": 30,
    "contexts": []
  },
  {
    "name": "Robert Trivers",
    "count": 30,
    "contexts": []
  },
  {
    "name": "Angela Merkel",
    "count": 30,
    "contexts": []
  },
  {
    "name": "Etienne Binant",
    "count": 30,
    "contexts": []
  },
  {
    "name": "Steve",
    "count": 30,
    "contexts": []
  },
  {
    "name": "Schultz",
    "count": 30,
    "contexts": []
  },
  {
    "name": "John Kerry",
    "count": 30,
    "contexts": []
  },
  {
    "name": "Thomas",
    "count": 30,
    "contexts": []
  },
  {
    "name": "Kenneth A Marra",
    "count": 30,
    "contexts": []
  },
  {
    "name": "Daniel Dennett",
    "count": 30,
    "contexts": []
  },
  {
    "name": "Madeleine Albright",
    "count": 29,
    "contexts": []
  },
  {
    "name": "Yitzhak",
    "count": 29,
    "contexts": []
  },
  {
    "name": "Conchita Sarnoff",
    "count": 29,
    "contexts": []
  },
  {
    "name": "Jacquie Johnson",
    "count": 29,
    "contexts": []
  },
  {
    "name": "Peter Aldhous",
    "count": 29,
    "contexts": []
  },
  {
    "name": "Carter",
    "count": 29,
    "contexts": []
  },
  {
    "name": "Agent Richards",
    "count": 29,
    "contexts": []
  },
  {
    "name": "Miro",
    "count": 29,
    "contexts": []
  },
  {
    "name": "Det Joe Recarey",
    "count": 29,
    "contexts": []
  },
  {
    "name": "General Alexander",
    "count": 29,
    "contexts": []
  },
  {
    "name": "Bilafonia",
    "count": 29,
    "contexts": []
  },
  {
    "name": "Sharon Churcher",
    "count": 28,
    "contexts": []
  },
  {
    "name": "Saddam Hussein",
    "count": 28,
    "contexts": []
  },
  {
    "name": "Warren Buffett",
    "count": 28,
    "contexts": []
  },
  {
    "name": "Benjamin Harnwell",
    "count": 28,
    "contexts": []
  },
  {
    "name": "Principals",
    "count": 28,
    "contexts": []
  },
  {
    "name": "Shamir",
    "count": 28,
    "contexts": []
  },
  {
    "name": "Gellman",
    "count": 28,
    "contexts": []
  },
  {
    "name": "Recarey",
    "count": 28,
    "contexts": []
  },
  {
    "name": "Investors",
    "count": 28,
    "contexts": []
  },
  {
    "name": "A Marie Villafana",
    "count": 28,
    "contexts": []
  },
  {
    "name": "Lanna Belohlavek",
    "count": 27,
    "contexts": []
  },
  {
    "name": "David Copperfield",
    "count": 27,
    "contexts": []
  },
  {
    "name": "Petty",
    "count": 27,
    "contexts": []
  },
  {
    "name": "Misha",
    "count": 27,
    "contexts": []
  },
  {
    "name": "Marine Le Pen",
    "count": 27,
    "contexts": []
  },
  {
    "name": "John Brockman",
    "count": 27,
    "contexts": []
  },
  {
    "name": "Martha Stewart",
    "count": 27,
    "contexts": []
  },
  {
    "name": "Van Buren",
    "count": 27,
    "contexts": []
  },
  {
    "name": "Herbie Hancock",
    "count": 27,
    "contexts": []
  },
  {
    "name": "Jacob Appelbaum",
    "count": 27,
    "contexts": []
  },
  {
    "name": "Carlyn",
    "count": 27,
    "contexts": []
  },
  {
    "name": "John Connolly",
    "count": 27,
    "contexts": []
  },
  {
    "name": "Susan Rice",
    "count": 27,
    "contexts": []
  },
  {
    "name": "Martin Nowak",
    "count": 27,
    "contexts": []
  },
  {
    "name": "Mark Epstein",
    "count": 27,
    "contexts": []
  },
  {
    "name": "Thomas Emerson Scott",
    "count": 27,
    "contexts": []
  },
  {
    "name": "Shimon",
    "count": 26,
    "contexts": []
  },
  {
    "name": "Empty",
    "count": 26,
    "contexts": []
  },
  {
    "name": "Hauser",
    "count": 26,
    "contexts": []
  },
  {
    "name": "Kelly",
    "count": 26,
    "contexts": []
  },
  {
    "name": "Sarah Ferguson",
    "count": 26,
    "contexts": []
  },
  {
    "name": "Jes Staley",
    "count": 26,
    "contexts": []
  },
  {
    "name": "Cohen",
    "count": 26,
    "contexts": []
  },
  {
    "name": "Paul Ryan",
    "count": 26,
    "contexts": []
  },
  {
    "name": "Julie K Brown",
    "count": 26,
    "contexts": []
  },
  {
    "name": "Randolph",
    "count": 26,
    "contexts": []
  },
  {
    "name": "Chris Tucker",
    "count": 26,
    "contexts": []
  },
  {
    "name": "Mahmoud Abbas",
    "count": 26,
    "contexts": []
  },
  {
    "name": "Michael Miller",
    "count": 26,
    "contexts": []
  },
  {
    "name": "Xi",
    "count": 26,
    "contexts": []
  },
  {
    "name": "Rodriguez",
    "count": 25,
    "contexts": []
  },
  {
    "name": "George Soros",
    "count": 25,
    "contexts": []
  },
  {
    "name": "Yossi Beilin",
    "count": 25,
    "contexts": []
  },
  {
    "name": "Deng Xiaoping",
    "count": 25,
    "contexts": []
  },
  {
    "name": "Mahmoud Ahmadinejad",
    "count": 25,
    "contexts": []
  },
  {
    "name": "Joscha Bach",
    "count": 25,
    "contexts": []
  },
  {
    "name": "Tom Pritzker",
    "count": 25,
    "contexts": []
  },
  {
    "name": "Sultan",
    "count": 25,
    "contexts": []
  },
  {
    "name": "Sean Spicer",
    "count": 25,
    "contexts": []
  },
  {
    "name": "Michael Cembalest",
    "count": 25,
    "contexts": []
  },
  {
    "name": "John Von Neumann",
    "count": 25,
    "contexts": []
  },
  {
    "name": "Eric Holder",
    "count": 25,
    "contexts": []
  },
  {
    "name": "Robert D Critton",
    "count": 25,
    "contexts": []
  },
  {
    "name": "Kavanaugh",
    "count": 25,
    "contexts": []
  },
  {
    "name": "Former Clinton",
    "count": 25,
    "contexts": []
  },
  {
    "name": "Melania Trump",
    "count": 24,
    "contexts": []
  },
  {
    "name": "Amanda Ens",
    "count": 24,
    "contexts": []
  },
  {
    "name": "Avraham Arnan",
    "count": 24,
    "contexts": []
  },
  {
    "name": "Mookie",
    "count": 24,
    "contexts": []
  },
  {
    "name": "John Roth",
    "count": 24,
    "contexts": []
  },
  {
    "name": "Sarah Palin",
    "count": 24,
    "contexts": []
  },
  {
    "name": "Summers",
    "count": 24,
    "contexts": []
  },
  {
    "name": "James Bamford",
    "count": 24,
    "contexts": []
  },
  {
    "name": "Thiel",
    "count": 24,
    "contexts": []
  },
  {
    "name": "Reid",
    "count": 24,
    "contexts": []
  },
  {
    "name": "Michael Hayden",
    "count": 24,
    "contexts": []
  },
  {
    "name": "Boris",
    "count": 24,
    "contexts": []
  },
  {
    "name": "Ernest Garcia",
    "count": 24,
    "contexts": []
  },
  {
    "name": "Jeffrey Sloman",
    "count": 24,
    "contexts": []
  },
  {
    "name": "Krischer",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Naomi Campbell",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Frank Gehry",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Sloman",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Juan Alessi",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Ben-porath",
    "count": 23,
    "contexts": []
  },
  {
    "name": "David Cameron",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Assange",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Stuart Russell",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Frank Wilczek",
    "count": 23,
    "contexts": []
  },
  {
    "name": "King Hussein",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Nadia",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Tonja Haddad Coleman",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Steve Jobs",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Siegel",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Ballentine",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Keynes",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Barrack",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Paul",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Anatoly Kucherena",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Sadat",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Ben Sasse",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Feinstein",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Abbas",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Brett Kavanaugh",
    "count": 23,
    "contexts": []
  },
  {
    "name": "Gwyneth Paltrow",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Tipper Gore",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Meir Amit",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Dan Shomron",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Raful",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Dan Meridor",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Kathy",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Plato",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Danny Hillis",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Chomsky",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Bernie Sanders",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Stephen Wolfram",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Monica Lewinsky",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Thomas Millar",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Richard Feynman",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Mark",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Barry Cohen",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Thorbj Jagland",
    "count": 22,
    "contexts": []
  },
  {
    "name": "Bono",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Olmert",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Attorney General",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Colin Firth",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Piaget",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Linda Stone",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Mike Tyson",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Prince Turki",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Mike Edmondson",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Nas",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Sarah Harrison",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Rudy Giuliani",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Ewen Macaskill",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Krauss",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Bill Burns",
    "count": 21,
    "contexts": []
  },
  {
    "name": "William French Smith",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Marvin Minsky",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Gary Cohn",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Pagliuca",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Jagland",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Viktor Orban",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Menninger",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Grant Smith",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Barbro C Ehnbom",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Jon Kyl",
    "count": 21,
    "contexts": []
  },
  {
    "name": "Boies",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Eli Zeira",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Amiram Levin",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Thomas Jefferson",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Emmy",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Alex",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Josh",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Charlie Rose",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Julie Taymor",
    "count": 20,
    "contexts": []
  },
  {
    "name": "David Brooks",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Paul Manafort",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Jabor",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Eva",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Bruce Wasserstein",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Sam Waksal",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Katie Johnson",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Noam",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Steven Pfeiffer",
    "count": 20,
    "contexts": []
  },
  {
    "name": "David Ingram",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Jeff Bezos",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Darren",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Donald Rumsfeld",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Goldberg",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Ryan",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Roger Penrose",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Michael Morell",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Villafana",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Laura Menninger",
    "count": 20,
    "contexts": []
  },
  {
    "name": "Nathan Myhrvold",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Chelsea Clinton",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Einstein",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Yigal",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Moshe",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Menachem Begin",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Ehud Olmert",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Dennis",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Faith Kates",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Dalai Lama",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Mnuchin",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Lenny Bruce",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Mitt Romney",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Samantha Power",
    "count": 19,
    "contexts": []
  },
  {
    "name": "James Risen",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Glenn Dubin",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Ariadne Calvo-platero",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Larry Page",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Christina Galbraith",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Jan Loeys",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Plaintiff",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Jimmy Carter",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Prince Sultan",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Ben Goertzel",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Don",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Kosslyn",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Jeffrey Herman",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Bofa Merrill Lynch Research Personnel",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Breyer",
    "count": 19,
    "contexts": []
  },
  {
    "name": "No Specific Individuals Mentioned",
    "count": 19,
    "contexts": []
  },
  {
    "name": "Rush Limbaugh",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Lefkowitz",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Brad Pitt",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Larry Gagosian",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Father",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Hamilton",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Shlomo",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Dick Cheney",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Haim Ramon",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Justin Bieber",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Nicole Kidman",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Albert Einstein",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Soon-yi",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Mike Pence",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Sarah Silverman",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Max Tegmark",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Clarisse",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Larry Keller",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Ron Paul",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Katie Walsh",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Ralph Lerner",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Pompeo",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Zubair Khan",
    "count": 18,
    "contexts": []
  },
  {
    "name": "David Pegg",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Michael Milken",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Edward Epstein",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Bazelon",
    "count": 18,
    "contexts": []
  },
  {
    "name": "James Clapper",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Powell",
    "count": 18,
    "contexts": []
  },
  {
    "name": "E O Wilson",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Runa A Sandvik",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Martin Luther King",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Det Dawson",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Ausa Villafana",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Thomas Barrack",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Frick",
    "count": 18,
    "contexts": []
  },
  {
    "name": "Kissinger",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Tom Ford",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Adam Smith",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Mother",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Nick Bostrom",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Ben",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Lena Dunham",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Martin",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Ann Coulter",
    "count": 17,
    "contexts": []
  },
  {
    "name": "David Deutsch",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Roger Stone",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Ledgett",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Ben Wizner",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Chris Christie",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Dina Powell",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Weingarten",
    "count": 17,
    "contexts": []
  },
  {
    "name": "John Murphy",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Harnwell",
    "count": 17,
    "contexts": []
  },
  {
    "name": "John Mcfarlane",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Miller",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Marcinkova",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Napoleon",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Lisa",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Sergey Brin",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Mitch Mcconnell",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Christine Ford",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Lyndon Johnson",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Saleh Abdullah Kamel",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Epstein",
    "count": 17,
    "contexts": []
  },
  {
    "name": "Belohlavek",
    "count": 17,
    "contexts": []
  }
];
